module.exports = __webpack_public_path__ + "assets/img/icon_job_responsibility@2x.c952087c.png";